import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { hasInCache } from '../../helper/cacheHelper';
import Parceiro from "../../components/classes/Parceiro";
import ParceiroDataSet from "../../components/data/parceiroDataset";
import Usuario from '../../components/classes/Usuario';
import UsuarioDataSet from "../../components/data/UsuarioDataSet";
import { UserContext } from "../../App";
import { useTranslation } from "react-i18next";

interface props {
    label: String;
    cacheKey: String;
    size: String;
    montaCache: boolean;
}

export default function AutoCompleteParceiro(param: props) {
    const { t } = useTranslation();
    const [value, setValue] = React.useState<string | null>(null);
    const [inputValue, setInputValue] = React.useState('');
    const [parceiros, setParceiros] = React.useState<Parceiro[]>([]);
    let dataSet = new ParceiroDataSet();
    let userDataSet = new UsuarioDataSet();
    const user: any = React.useContext(UserContext);

    React.useEffect(() => {

        if (user.isRoot) {
            dataSet.ListarAtivos().then((response) => {
                setParceiros(response);
                dataSet.AdicionarListaAoCache(response);
            });
        } else {
            let storageUser: Usuario = JSON.parse(
                String(localStorage.getItem(userDataSet.getKeyCach()))
            );
            dataSet.ListarAtivosPorUsuario(+storageUser.id).then((response) => {
                setParceiros(response);
                dataSet.AdicionarListaAoCache(response);
            });
        }

        if (hasInCache(dataSet.getKeyCachId()))
            setInputValue(String(localStorage.getItem(dataSet.getKeyCachId())))
    }, []);

    const handlerValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    };

    return (
        <Autocomplete
            noOptionsText={t("pages.partners.text.autoCompleteNoOptions")}
            disablePortal
            id="parceiro-AutoComplete"
            size='small'
            options={parceiros.map((option: any) => option.codigoFornecedorSAP + ' - ' + option.grupo)}
            sx={{ width: 450, fontFamily: 'NotoSans-Regular', fontSize: 8 }}
            renderInput={(params) =>
                <TextField {...params} label={param.label}
                    value={value}
                    onChange={handlerValueChange}
                />
            }
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            onBlur={() => {
                if (param.montaCache) {
                    var _parceiro: Parceiro | undefined = parceiros.find(f => f.codigoFornecedorSAP + ' - ' + f.grupo === inputValue);
                    if (_parceiro) {
                        dataSet.AdicionarCodigoFornecedorSapAoCache(Number(_parceiro.codigoFornecedorSAP));
                        dataSet.AdicionarGrupoAoCache(String(_parceiro.apelido));
                        dataSet.AdicionarIdAoCache(Number(_parceiro.id));
                        dataSet.AdicionarObjetoAoCache(_parceiro);
                    }
                    window.location.assign("/");
                }
                else {
                    localStorage.setItem(String(param.cacheKey), inputValue);
                }
            }}
        />
    );
}


